import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ChipDropdownComponent } from '../../../../shared/payee-cases/chip-dropdown/chip-dropdown.component';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';

@Component({
  selector: 'app-email-filter',
  templateUrl: './email-filter.component.html',
  styleUrls: ['./email-filter.component.scss'],
  imports: [
    ChipDropdownComponent,
    PayeeFormFieldComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class EmailFilterComponent implements OnInit, OnDestroy {
  private readonly destroy = new Subject<void>();
  readonly formControl = new FormControl<string | null>(null);
  dropdownOpen = false;

  @Input() value: string | null = null;
  @Output() valueChange = new EventEmitter<string | null>();

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(takeUntil(this.destroy))
      .subscribe((v) => {
        this.value = v;
        this.valueChange.emit(this.value);
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
  }

  removed(): void {
    this.value = null;
    this.valueChange.emit(this.value);
    this.dropdownOpen = false;
    this.formControl.patchValue(null);
  }
}
